import React, { memo, useEffect, useState } from "react";
import Product1 from "../../assets/images/product1.jpg";
import Product2 from "../../assets/images/product2.jpg";
import MenuContainer from "../../Components/MenuContainer/MenuContainer";
import ThambnailList from "../../Components/ThambnailList/ThambnailList";
import PreviewComponet from "../../Components/PreviewComponent/PreviewComponet";
import { ManageApis } from "../../AppServices/ManageApi";
import {
  getBase64,
  getLocalStorage,
  setLocalStorage,
  suportFile,
  urlToBase64,
} from "../../Functions/Utils";
import { handleExtraction } from "../../Functions/HandleExtraction";
import { ResponseUpload } from "../../Functions/ResponseUpload";
import Loader from "../../Components/LoaderComponent/Loader";
import { useLocation, useParams } from "react-router-dom";
import AlertBox from "../../Components/AlertBox/AlertBox";
import { useStoreValues } from "../../Context/storeProvider";
import Uploadfiles from "../UploadFiles/Uploadfiles";
import ExtractingLoader from "../ExtractingLoader/ExtractingLoader";

let comp = true;
function MainWrapper({
  selectedMenu,
  isdoubleSide,
  documentSideKeys,
  headerName,
  setisToggled,
  isToggled,
}) {
  const { menuList, uploadSide, setUploadSide } = useStoreValues();
  const [thambnailDataList, setThambnailDataList] = useState([]);
  const [selectedData, setselectedData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [newLoading, setnewLoading] = useState(false);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [Uploaded, setUploaded] = useState(false);
  // const [uploadSide, setUploadSide] = useState(true)
  const [Loader, setLoader] = useState(false);
  const [aofRefId, setAofRefId] = useState(null);
  const [aofResponse, setAofResponse] = useState(null);

  const side = isdoubleSide ? documentSideKeys[0]?.value : "NoSide";

  const [selectedSide, setSelectedSide] = useState(
    // isdoubleSide && documentSideKeys[0]?.value
    side
  );

  const AlertinitialValue = {
    show: false,
    message: "",
    isfalse: false,
    isSuccess: false,
    isWarning: false,
  };
  useEffect(() => {
    console.log(selectedData);
  }, [selectedData]);

  const [showAlert, setShowAlert] = useState(AlertinitialValue);

  const { pathname } = useLocation();
 
  useEffect(() => {
    setSelectedSide(side);
  }, [pathname]);

  useEffect(() => {
    // //console.log(menuList)
  }, [menuList]);

  

  
  let suportFiles = [".png", ".jpeg", ".jpg", ".pdf"];
  //check status for the upload arco
  const handleFileUpload = async (e) => {
    setnewLoading(true);

    const files = e[0].originFile;
    let fileExt = files?.name?.split(".").pop();
    const base64 = await getBase64(files);
    // //console.log(files[0], fileExt, base64);

    if (files.size <= 3145728) {
      if (await suportFile(fileExt, suportFiles)) {
        try {
          if (e[0].status == "uploading") {
            let response = await handleExtraction(
              base64,
              fileExt,
              selectedMenu,
              selectedSide,
              menuList
            );
            setnewLoading(false);
            setAofRefId(response.response_data.refId);
            setLocalStorage({ currentBase64: base64 });

            if (
              selectedMenu == "CANADIANDL" &&
              response?.response_data?.status == "Error"
            ) {
              setShowAlert((pre) => ({
                ...pre,
                show: true,
                message:  response?.message,
                isfalse: false,
              }));
              localStorage.removeItem("currentBase64") 
              return
            }
            if (
              response.message === "Success" &&
              response.response_data?.status != "Error" && selectedMenu == "CANADIANDL"
            ) {
              setThambnailDataList([]);
              setThambnailDataList(response?.response_data);
              //setselectedData(response?.response_data)
              setUploaded(true);
              setUploadSide(false);
              return
            }
             else {
              setShowAlert((pre) => ({
                ...pre,
                show: true,
                message:
                  response.message == "Success"
                    ?
                       response?.response_data?.message
                    : response.message,
                isWarning: true,
                isfalse: false,
              }));
              // else case for response fails from ai
              document.getElementById("upload").value = "";
              setnewLoading(false);
            }
          }
        } catch (error) {
          // //console.log(error);
        }
      }
      // else case for upload image not suport
      else {
        setnewLoading(false);
        setShowAlert((pre) => ({
          ...pre,
          show: true,
          message: "File not supported",
          isfalse: false,
          isWarning: true,
        }));
      }
    } else {
      setnewLoading(false);
      setShowAlert((pre) => ({
        ...pre,
        show: true,
        message: "File size is greater than 3MB",
        isfalse: false,
        isWarning: true,
      }));
    }
  };
  
  return (
    <>
      {isLoading && <Loader />}
   
      <AlertBox
        show={showAlert.show}
        message={showAlert.message}
        enableFailIcon={showAlert.isfalse}
        enableSuccessIcon={showAlert.isSuccess}
        enableWarningIcon={showAlert.isWarning}
        handlecancel={() => setShowAlert(AlertinitialValue)}
      />

      {newLoading ? (
        <ExtractingLoader setisToggled={setisToggled} isToggled={isToggled} />
      ) : uploadSide ? (
        <Uploadfiles
          accept={suportFiles}
          handleFileUpload={handleFileUpload}
          dataList={thambnailDataList}
          selectedData={setselectedData}
          setUploadSide={setUploadSide}
          headerName={headerName}
          setisToggled={setisToggled}
          isToggled={isToggled}
          fileUploaded={Uploaded}
          setFileUploaded={setUploaded}
          documentSideKeys={documentSideKeys}
          setSelectedSide={setSelectedSide}
          selectedSide={selectedSide}
            Loader={Loader}
            selectedMenu={selectedMenu}
          />
          
      ) : (
        <div className="d-block d-md-flex w-100">
        
          <>
           
            <MenuContainer
              headerName={headerName}
              setisToggled={setisToggled}
              isToggled={isToggled}
            >
             

              <PreviewComponet
                responseData={selectedData}
                selectedMenu={selectedMenu}
                selectedSide={selectedSide}
                setUploadSide={setUploadSide}
                aofResponse = {aofResponse}
              />
            </MenuContainer>
          </>
     
        </div>
      )}
    </>
  );
}

export default memo(MainWrapper);
